import React from 'react';
import { useDispatch } from 'react-redux';
import styled from 'styled-components';
import devices from '~/styles/devices';
import { openHelp } from '~/store/modules/help/actions';

const Button = styled.button`
  position: absolute;
  bottom: 0;
  cursor: pointer;
  width: 100%;
  height: 59px;
  display: flex;
  justify-content: center;
  align-items: center;
  color: ${({ theme }) => theme.colors.institucionalDark};
  font-size: 0.9375rem;
  font-weight: 600;
  background-color: ${({ theme }) => theme.colors.secondary};
  border: none;
  border-radius: 15px 15px 0 0;

  @media (min-width: ${devices.tablet}) {
    display: none;
  }
`;

export default function HelpButton() {
  const dispatch = useDispatch();
  return (
    <Button onClick={() => dispatch(openHelp())} type="button">
      Precisa de ajuda ou atendimento?
    </Button>
  );
}
